export const buildWhatsappHref = (rawNumber, message) => {
  const number = String(rawNumber || '').replace(/\D/g, '');
  if (!number) return null;

  const internationalNumber = number.length === 10 ? `52${number}` : number;
  const base = `https://wa.me/${internationalNumber}`;
  return message && message.trim()
    ? `${base}?text=${encodeURIComponent(message.trim())}`
    : base;
};

export const getFloatingWhatsappHref = (companyInfo) => {
  const contact = companyInfo?.contactInfo?.find((entry) =>
    entry?.type === 'whatsapp' && buildWhatsappHref(entry.value)
  );
  return buildWhatsappHref(
    contact?.value || import.meta.env.VITE_WHATSAPP_NUMBER || '525540843309'
  );
};
